import { SettingsAccountPage } from '@/ui/routes/settings/routes/account'
import '@assets/styles/index.scss'
import { ROUTES } from '@core/config/routing'
import DashboardLayout from '@layouts/dashboard/dashboard.layout'
import SettingsRoot from '@routes/settings/settings.route'
import { Navigate, Route, Routes } from 'react-router-dom'

const MfaEnforcementRouter = () => {
    return (
        <Routes>
            <Route key={1} element={<DashboardLayout />}>
                <Route
                    path={ROUTES.settings.children.account.path}
                    element={<SettingsRoot />}
                >
                    <Route
                        path={ROUTES.settings.children.account.path}
                        element={<SettingsAccountPage />}
                    />
                </Route>
            </Route>
            <Route
                key={2}
                path="*"
                element={
                    <Navigate to={ROUTES.settings.children.account.path} />
                }
            />
        </Routes>
    )
}

export { MfaEnforcementRouter, ROUTES }
export type TAppRouter = typeof MfaEnforcementRouter
